import { z } from 'zod';
import { idSchema, emailSchema } from './common.js';
import { driverEngagementTypeSchema, e164Schema, invitableBadgeSchema } from './fleet.js';
import { calendarDateSchema } from './vehicle.js';
// -------- Team invites (0050 driver rail, widened 0075) --------
export const createDriverInviteBodySchema = z
    .object({
    name: z.string().trim().min(1, 'Name required').max(120),
    email: emailSchema,
    /** Captured for the record; delivery is email-only (no SMS provider). */
    phoneE164: e164Schema.nullable().optional(),
    /** Badge set the invite seats. Defaults to Driver-only — the pre-0075
     *  DM-invite body stays valid verbatim. Owner never invitable. */
    roles: z.array(invitableBadgeSchema).min(1).max(4).default(['driver']),
    /** Required iff the Driver badge is included; must be absent otherwise. */
    engagementType: driverEngagementTypeSchema.optional(),
})
    .strict()
    .refine((b) => b.roles.includes('driver') === (b.engagementType !== undefined), {
    message: 'Engagement type is required for Driver invites and only for them',
    path: ['engagementType'],
});
export const driverInviteIdParamSchema = z.object({
    fleetId: idSchema,
    inviteId: idSchema,
});
/** Authed code redemption (existing users) — same codes the onboarding
 *  fleet stage takes: fleet join codes and driver-invite codes. */
export const redeemCodeBodySchema = z
    .object({
    code: z.string().trim().min(4).max(12),
})
    .strict();
// -------- Driver compliance (0051) --------
export const driverComplianceDocTypeSchema = z.enum(['goods_in_transit', 'public_liability']);
export const upsertDriverComplianceBodySchema = z
    .object({
    reference: z.string().trim().max(80).nullable().optional(),
    insurer: z.string().trim().max(80).nullable().optional(),
    issuedAt: calendarDateSchema.nullable().optional(),
    expiresAt: calendarDateSchema,
})
    .strict();
export const driverComplianceParamSchema = z.object({
    fleetId: idSchema,
    memberId: idSchema,
    type: driverComplianceDocTypeSchema,
});
// -------- Driver App v2 (0062/0063): availability + self-serve uploads ----
export const driverAvailabilityBodySchema = z
    .object({
    isAvailable: z.boolean(),
})
    .strict();
export const driverComplianceSelfParamSchema = z.object({
    fleetId: idSchema,
    type: driverComplianceDocTypeSchema,
});
/** Same whitelist as POD uploads: camera formats + PDF certificates. */
export const complianceUploadMimeSchema = z.enum([
    'image/jpeg',
    'image/png',
    'image/heic',
    'image/webp',
    'application/pdf',
]);
/** 15MB cap per certificate — generous for a phone photo or scanned PDF. */
export const COMPLIANCE_MAX_FILE_BYTES = 15 * 1024 * 1024;
export const complianceUploadInitBodySchema = z
    .object({
    fileName: z.string().trim().min(1).max(160),
    mimeType: complianceUploadMimeSchema,
    sizeBytes: z.number().int().min(1).max(COMPLIANCE_MAX_FILE_BYTES),
})
    .strict();
/** Dispatcher confirm: the fleet's check of a driver upload — records the
 *  dated details the file evidences. */
export const confirmDriverComplianceBodySchema = z
    .object({
    expiresAt: calendarDateSchema,
    reference: z.string().trim().max(80).nullable().optional(),
    insurer: z.string().trim().max(80).nullable().optional(),
    issuedAt: calendarDateSchema.nullable().optional(),
})
    .strict();
//# sourceMappingURL=driver.js.map